<template lang="pug">
  .sublayer.pa-4
    slot
</template>

<script>
export default {
  name: "app-sublayer",
}
</script>

<style lang="scss" scoped>
.sublayer {
  background-color: #505254;
  border-radius: 5px;
}
</style>